import { COVERGO_SAAS_DEV } from "../consts.js"

export const ktaxa = {
	"ktaxa-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "ktaxa_dev",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}
